import React, { useState } from "react";
import { useRef } from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  withStyles,
} from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import { Paper, TextField, Grid } from "@material-ui/core";
import { useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Link, useParams } from "react-router-dom";
import { TableFooter, TablePagination } from "@material-ui/core";
import { generateCustomerReportFilterUrl } from "../../helpers/generateUrl";
import { getAllCustomerReport, getReportTemplate, } from "../actions/LimsAdminActions";
import { useNavigate } from 'react-router-dom';
import Autocomplete from '@mui/material/Autocomplete';
import TicketCommentsModal from "../pages/comment";
import { MessageRounded } from "@material-ui/icons";
import DownloadIcon from '@mui/icons-material/Download';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
    },
    leftContentHeader: {
      width: "70%",
      float: "left",
    },
    rightContentHeader: {
      width: "30%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    contentTable: {
      width: "100%",
      minHeight: "400px",
    },
    contentFilter: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    card: {
      height: "100%",
      padding: theme.spacing(1),
    },
    card_grid: {
      justifyContent: "space-between",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    tableHead: {
      background: "rgb(146, 74, 145)!important",
    },
  })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#1C4E80",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
interface Props {
  getAllCustomerReport: any;
  customerReportList: any;
  loading: any;
  getReportTemplate: any;
  reportList: any;
}
const StopsPlace: React.FC<Props> = ({
  getAllCustomerReport,
  customerReportList,
  loading,
  getReportTemplate,
  reportList,
}) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const timer = useRef<any>(0);
  const [page, setPage] = React.useState(0);
  const [patientName, setPatient] = useState<any>("");
  const [bookingId, setBookingId] = useState<any>("");
  const [caseId, setCaseId] = useState<any>("");
  const [templateId, setTemplateId] = useState<any>("");
  const [createStartDate, setCreateStartDate] = useState("");
  const [createEndDate, setCreateEndDate] = useState("");
  const [openModal, setopenModal] = useState<boolean>(false);
  const [reportData, setReportData] = useState<any>("")

  const filterCustomerReport = () => {
    const body: any = {
      bookingId,
      caseId,
      templateId,
      patientName,
      createStartDate,
      createEndDate
    };
    const url = generateCustomerReportFilterUrl(body).substring(2);
    getAllCustomerReport(`${url}`);
    setPage(0);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url =
        customerReportList?.links &&
        customerReportList?.links.next.split("?")[1];
      getAllCustomerReport(url);
    } else if (newPage < page) {
      let url =
        customerReportList?.links &&
        customerReportList?.links.previous.split("?")[1];
      getAllCustomerReport(url);
    }
    setPage(newPage as number);
  };

  useEffect(() => {
    getAllCustomerReport();
    getReportTemplate();
  }, []);

  const resethandler = () => {
    getAllCustomerReport();
    localStorage.removeItem("CEBookingFilter");
    navigate(0)
  }
  const handleClick = (data: any) => {
    setopenModal(true);
    setReportData(data?.booking);
  };
  // add template code 

  const templateCodes = ["NSP", "BRCA", "NIPT", "Allergy", "ABL", "HLA", "JAK", "PML", "MCC", "BCRQ", "QFPCR", "CMA315", "SANGERSEQUENCING", "HBB",
    "CMA750", "DNA", "SMNMLPA", "DMDMLPA", "IRMA", "FACTORV", "FACTORII", "PAP-SMEAR", "MEN1"];
  const templateRouteMap: any = {
    MEN1: "men1-gene-sequencing",
    MEN1GENESEQUENCING: "men1-gene-sequencing",
  };
  const getTemplateRoute = (data: any) => {
    const templateCode = data?.template_code;
    if (data?.template_name === "MEN1 Gene Sequencing") {
      return "men1-gene-sequencing";
    }
    if (!templateCode || !templateCodes.includes(templateCode)) {
      return "";
    }
    return templateRouteMap[templateCode] || `${templateCode.toLowerCase()}-report`;
  };

  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <div className={classes.contentHeader}>
        <div className={classes.leftContentHeader}>
          <h4 style={{ fontWeight: "bold" }}>CUSTOMER REPORT LIST </h4>
        </div>
      </div>
      <div className={classes.contentFilter}>
        <Grid
          container
          spacing={1}
          direction="row"
          style={{ alignItems: "left" }}
        >
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              label="Booking Id"
              variant="outlined"
              className="input"
              fullWidth
              type="number"
              value={bookingId}
              onChange={(e) => setBookingId(e.target.value)}
              style={{ width: "100%" }}
            />
          </Grid>
          {/* <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Case Id"
              variant="outlined"
              className="input"
              fullWidth
              type="number"
              value={caseId}
              onChange={(e) => setCaseId(e.target.value)}
              style={{ width: "100%" }}
            />
          </Grid> */}
          <Grid item xs={12} sm={4} md={3}>
            <Autocomplete
              id="patienName"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setTemplateId(obj?.id);
                }
              }}
              options={reportList || []}
              freeSolo
              blurOnSelect
              aria-required
              getOptionLabel={(option: any) => option.template_name}
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {

                }, 1000);
                if (newInputValue.length === 0) {
                  setTemplateId(0);
                }
              }}
              renderInput={(params) => (
                <TextField
                  className="input"
                  {...params}
                  label="Template Name"
                  variant="outlined"
                  style={{ width: "100%", margin: "0", padding: "0" }}
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <Autocomplete
              id="patienName"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setPatient(obj?.patient_name);
                }
              }}
              options={customerReportList.results || []}
              freeSolo
              blurOnSelect
              aria-required
              getOptionLabel={(option: any) => option.patient_name}
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getAllCustomerReport(`${newInputValue}`);
                }, 1000);
                if (newInputValue.length === 0) {
                  setPatient(0);
                }
              }}
              renderInput={(params) => (
                <TextField
                  className="input"
                  {...params}
                  label="Patient Name"
                  variant="outlined"
                  style={{ width: "100%", margin: "0", padding: "0" }}
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              type="submit"
              style={{ height: "100%" }}
              onClick={filterCustomerReport}
            >
              Filter
            </Button>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              color="secondary"
              variant="contained"
              fullWidth
              style={{ height: "100%" }}
              onClick={() => resethandler()}

            >
              reset
            </Button>
          </Grid>
        </Grid>
        <TableContainer
          className={classes.tableContainer}
          component={Paper}
          style={{ maxHeight: "550px" }}
        >
          <Table stickyHeader aria-label="simple table">
            <TableHead className={classes.tableHead}>
              <StyledTableRow>
                <StyledTableCell align="center">Customer Report</StyledTableCell>
                <StyledTableCell align="center">Patient Name</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Booking Id</StyledTableCell>
                <StyledTableCell align="center">Template Name</StyledTableCell>
                <StyledTableCell align="center">Download Report</StyledTableCell>
                <StyledTableCell align="center">Logs</StyledTableCell>
                <StyledTableCell align="center">Action</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {customerReportList &&
                customerReportList?.results &&
                customerReportList?.results?.length > 0 &&
                customerReportList?.results?.map((data: any, index: any) => {
                  return (
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        <Link
                          to={`/dashboard/la/upload_report/${data?.booking}/${data?.template_code}`}
                          style={{ textDecoration: "none" }}
                        >
                          <Button
                            variant="contained"
                            style={{ background: data?.status === "Draft" ? "#085ca1" : "#1e7f82" }}
                            onClick={(e) => {
                              if (data?.status === "Draft") {
                                e.preventDefault();
                                return;
                              }
                              // Handle button click event
                            }}
                          >
                            Send Report
                          </Button>
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.patient_name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.status}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.booking}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.template_name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.report_url ?
                          <a href={data?.report_url} target="_blank" rel="noreferrer" download><DownloadIcon /></a>
                          : "Report Not Uploaded"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <div>
                          <MessageRounded
                            onClick={() => handleClick(data)}
                          />
                        </div>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {getTemplateRoute(data) ? (
                          <Link
                            to={`/dashboard/la/${getTemplateRoute(data)}/${data?.booking}/${data?.template}/edit`}
                            style={{ textDecoration: "none" }}
                          >
                            <Button variant="contained" color="secondary">
                              Action
                            </Button>
                          </Link>
                        ) : null}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
            <TableFooter>
              <StyledTableRow>
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={customerReportList?.count || 0}
                  rowsPerPage={customerReportList?.page_size}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </StyledTableRow>
            </TableFooter>
          </Table>
        </TableContainer>
        <TicketCommentsModal
          openModal={openModal}
          setopenModal={setopenModal}
          reportData={reportData}
        />
      </div>
    </main>
  );
};
const mapStateToProps = (state: any) => ({
  customerReportList: state.LimsAdminReducer.customerReportList,
  reportList: state.LimsAdminReducer.reportList,
});
export default connect(mapStateToProps, {
  getAllCustomerReport,
  getReportTemplate,
})(StopsPlace);
